import {defineMessages} from "@project/i18n";

export const supplierFieldLabelIds = {
  address: "fields.supplier.address",
  companyId: "fields.supplier.companyId",
  companyName: "fields.supplier.companyName",
  country: "fields.supplier.country",
  deliveryTimeDays: "fields.supplier.deliveryTimeDays",
  logoUrl: "fields.supplier.logoUrl",
  paymentTimeDays: "fields.supplier.paymentTimeDays",
  phoneNumber: "fields.supplier.phoneNumber",
  phonePrefix: "fields.supplier.phonePrefix",
  roles: "fields.supplier.roles",
  standardization: "fields.supplier.standardization",
  status: "fields.supplier.status",
  websiteUrl: "fields.supplier.websiteUrl",
} as const;

export const supplierFieldMessages = defineMessages({
  address: {
    id: "fields.supplier.address",
    defaultMessage: "Address",
    description: "Supplier company address",
  },
  companyId: {
    id: "fields.supplier.companyId",
    defaultMessage: "Company ID",
    description: "Supplier company registration identifier",
  },
  companyName: {
    id: "fields.supplier.companyName",
    defaultMessage: "Company name",
    description: "Supplier company name",
  },
  country: {
    id: "fields.supplier.country",
    defaultMessage: "Country",
    description: "Supplier company country",
  },
  deliveryTimeDays: {
    id: "fields.supplier.deliveryTimeDays",
    defaultMessage: "Delivery time (days)",
    description: "Supplier delivery calendar days",
  },
  logoUrl: {
    id: "fields.supplier.logoUrl",
    defaultMessage: "Logo URL",
    description: "Supplier optional logo URL",
  },
  paymentTimeDays: {
    id: "fields.supplier.paymentTimeDays",
    defaultMessage: "Payment time (days)",
    description: "Supplier payment calendar days",
  },
  phoneNumber: {
    id: "fields.supplier.phoneNumber",
    defaultMessage: "Phone number",
    description: "Supplier company phone number",
  },
  phonePrefix: {
    id: "fields.supplier.phonePrefix",
    defaultMessage: "Phone prefix",
    description: "Supplier company phone region",
  },
  roles: {
    id: "fields.supplier.roles",
    defaultMessage: "Roles",
    description: "Supplier commercial roles",
  },
  standardization: {
    id: "fields.supplier.standardization",
    defaultMessage: "Standardization",
    description: "Supplier informational standardization",
  },
  status: {
    id: "fields.supplier.status",
    defaultMessage: "Status",
    description: "Supplier status",
  },
  websiteUrl: {
    id: "fields.supplier.websiteUrl",
    defaultMessage: "Website URL",
    description: "Supplier company website URL",
  },
});
